/**
 * PROGRESS ONLY. `blocked` left this union on 10 Oct 2026.
 *
 * Blocking used to be a value here, which meant it REPLACED the progress state
 * and releasing had to guess what to restore. It now lives in `stage_blocks`,
 * so a stage carries its progress and its blocked-ness independently -- see
 * `TaskStageView.block`.
 *
 * The database enum still has a vestigial `blocked` value, because Postgres
 * cannot remove one. A trigger refuses it.
 */
export const STAGE_STATES = [
    "not_started",
    "in_progress",
    "complete",
];
/**
 * The longest a stage's instructions may be, in characters. The column is
 * `text` and has no limit; this is the ceiling the API refuses beyond, so a
 * stray paste of a whole document is stopped, and the editor counts against
 * the same number. 10,000 from 25 Sep 2026; Jeremy raised it to 75,000 on
 * 28 Oct, when the longest on production (a report's Draft) was 8,260.
 */
export const STAGE_INSTRUCTIONS_MAX = 75_000;
/**
 * What to do about each reason. ONE wording, read by the API's refusal and by
 * the task page's warning, so the two cannot drift into saying different
 * things about the same stage.
 */
export function unreadyFix(missing) {
    switch (missing) {
        case "nobody on it":
            return "Add someone to it first";
        case "no hours":
            return "Give it hours first — 0 is fine for a stage that is only waiting";
        case "no date":
            return "Give it a due date first — the task's PM / Task Manager or an admin sets dates";
    }
}
/**
 * Images in a note (Jeremy, 3 Nov 2026): up to five, each at most 5 MB as
 * picked or pasted -- the browser shrinks them before sending, and the server
 * holds what arrives to the same ceiling -- and only these three kinds.
 */
export const NOTE_IMAGES_MAX = 5;
export const NOTE_IMAGE_BYTES_MAX = 5 * 1024 * 1024;
export const NOTE_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const MANAGED_AS = [
    "owner",
    "deliverable_pm",
    "deliverable_tm",
    "project_pm",
    "project_tm",
];
/** How far back My work's Done section reaches. */
export const FINISHED_RECENT_DAYS = 30;
/** The widest range the Finished work page searches at once: two years. */
export const FINISHED_MAX_DAYS = 731;
/** At most this many rows come back; `more` says there were others. */
export const FINISHED_MAX_ROWS = 500;
export const DATE_CHANGE_REASONS = [
    "Client delay",
    "Scope change",
    "Resourcing",
    "Waiting on dependency",
    "Internal rework",
    "Other",
];
/**
 * The RULES that change work on nobody's behalf, by the label each writes as
 * its actor -- `systemActor()` in the API, into `activity.actor_oid` and
 * `notifications.actor_rule`. Nobody did these, so a screen must say which
 * rule did rather than "Someone" (22 Oct 2026): that reads as a person whose
 * name we lost.
 */
export const RULE_ACTORS = [
    /** A block released because the stage it waited on was reached. */
    "system:stage-condition",
    /** A snoozed block woken by its check-back date. */
    "system:snooze-date",
    /** A block open too long, hibernated. */
    "system:hibernation-sweep",
    /** A linked deployment's dates, crew and hours put on its stage. */
    "system:resource-scheduler",
    /** Work already on an end stage that finishes on arrival, closed by 20261021T2340. */
    "system:end-stage",
];
export function isRuleActor(label) {
    return RULE_ACTORS.includes(label);
}
//# sourceMappingURL=workflow.js.map